import { render, staticRenderFns } from "./CaTester.vue?vue&type=template&id=d6afcb12&"
import script from "./CaTester.vue?vue&type=script&lang=ts&"
export * from "./CaTester.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./CaTester.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6afcb12')) {
      api.createRecord('d6afcb12', component.options)
    } else {
      api.reload('d6afcb12', component.options)
    }
    module.hot.accept("./CaTester.vue?vue&type=template&id=d6afcb12&", function () {
      api.rerender('d6afcb12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CaTester.vue"
export default component.exports